import { Injectable } from '@angular/core';
import { Observable ,  Subject ,  BehaviorSubject } from 'rxjs';
import { orderBy } from 'lodash';
import { HttpClient, HttpResponse, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import * as _ from 'lodash';

import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { MY_PRODUCTS } from 'shared/search/search-service-types';
import { Config } from 'shared/config/env.config';
import { statusLookup } from 'shared/my-products/my-products-statuses';


@Injectable()
export class MyProductsSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  serviceType = MY_PRODUCTS;
  idField = 'itemId';

  statusLookup: Array<any> = statusLookup;
  doUpdate: boolean = true;

  getSearchURI(brandId: string, searchModel: SearchModel): string {
    let searchUri: string;
    const type = searchModel.route;
    const id = searchModel.searchId;
    if (type === 'import-review-aces') {  searchUri = '/apps/' + brandId + '/imported'; }
    if (type === 'import-review-pies') {  searchUri = '/items/' + brandId + '/imported'; }
    if (type === 'import-review-custom-fields') { searchUri = '/items/' + brandId + '/imported'; }
    if (type === 'working') {         searchUri = '/items/' + brandId + '/working'; }
    if (type === 'published') {   searchUri = '/items/' + brandId + '/published'; }
    if (type === 'view-export') {         searchUri = '/items/' + brandId + '/exported-mongo'; }
    if (id) { searchUri += '/' + id.toString(); }
    return searchUri;
  }

  runSearch(brandId: string, searchModel: SearchModel, doUpdate: boolean = true): Observable<any> {
    this.doUpdate = doUpdate;
    return super.runSearch(brandId, searchModel);
  }

  handleSearchRes(res: any) {
    if (this.doUpdate) {
      this.updateData(res);
    }
  }

  getListFilterState(): string {
    switch (this.searchModel.route) {
      case 'import-review-aces':
      case 'import-review-pies':
      case 'import-review-custom-fields':
        return 'imported';
      case 'working':
        return 'working';
      case 'published':
        return 'published';
      case 'view-export':
        return 'exported';
      default:
        return '';
    }
  }
}
